const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const postInquiry = async (inquiryData: {
  name: string;
  email: string;
  phone: string;
  inquiry: string;
  product: string;
  company?: string;
  country: string;
  recaptchaToken: string;
}) => {
  const response = await fetch(`${API_BASE_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(inquiryData),
  });

  if (!response.ok) {
    throw new Error('Failed to submit inquiry');
  }

  return response.json();
};

export const postGeneralInquiry = async (inquiryData: {
  name: string;
  email: string;
  phone: string;
  inquiry: string;
  company?: string;
  country: string;
  recaptchaToken: string;
}) => {
  const response = await fetch(`${API_BASE_URL}/general`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(inquiryData),
  });

  if (!response.ok) {
    throw new Error('Failed to submit general inquiry');
  }

  return response.json();
};
